"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = validatePassword;

var _getValidCombination = _interopRequireDefault(require("./getValidCombination"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DEFAULT_CONFIG = {
  minLength: 8,
  minCombination: 2
}; // In createValidator, the 2nd parameter is previousValue . And since config is required, it is better to put it as the 3rd param.

function validatePassword(value, previousValue) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_CONFIG;
  var minLength = config.minLength,
      minCombination = config.minCombination;

  if (typeof value !== 'string') {
    return {
      message: 'validation.password.invalidParam'
    };
  }

  if (value.length < minLength) {
    return {
      message: 'validation.minLength',
      value: 8
    };
  }

  var validCombination = (0, _getValidCombination["default"])(value);

  if (validCombination["true"] < minCombination) {
    return {
      message: 'validation.password.weakCombination'
    };
  }

  return null;
}